// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-m_gO","advertDetailParameterList__header":"c-m_gP","advertDetailParameterList__list":"c-m_gQ"};